import React from 'react';
import './Login.css'; // Reuse login styles for consistency

function PrivacyPolicy() {
  return (
    <div className="login-page-bg" style={{ paddingTop: '5vh', alignItems: 'flex-start' }}>
      <div className="login-card" style={{ maxWidth: '800px', padding: '2rem' }}>
        <h1 style={{ marginBottom: '1.5rem', color: 'var(--text-primary)' }}>Privacy Policy</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          <strong>Last updated:</strong> February 11, 2026
        </p>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>1. Information We Collect</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We collect information you provide directly, including:
          </p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>Name and email address</li>
            <li>Phone number (optional)</li>
            <li>Account credentials</li>
            <li>Transaction and activity data</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>2. How We Use Your Information</h3>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>To provide and maintain our services</li>
            <li>To authenticate your account</li>
            <li>To send verification codes and important notifications</li>
            <li>To improve our platform and user experience</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>3. Information Sharing</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We do not sell your personal information. We may share data with:
          </p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>Service providers (e.g., SMS verification via Twilio)</li>
            <li>Legal authorities when required by law</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>4. Data Security</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We implement industry-standard security measures to protect your data, including encryption 
            and secure storage. However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>5. Your Rights</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            You have the right to:
          </p>
          <ul style={{ color: 'var(--text-secondary)', paddingLeft: '1.5rem', lineHeight: 1.8 }}>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account</li>
            <li>Opt out of marketing communications</li>
          </ul>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>6. Cookies</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We use essential cookies to maintain your session and preferences. 
            We do not use tracking cookies for advertising purposes.
          </p>
        </section>

        <section style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>7. Contact Us</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            If you have questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:thebrainpicks@gmail.com" style={{ color: 'var(--accent-primary)' }}>
              thebrainpicks@gmail.com
            </a>
          </p>
        </section>

        <section>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '0.5rem' }}>8. Changes to This Policy</h3>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
            We may update this Privacy Policy from time to time. We will notify you of any changes 
            by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;